import React from 'react';
import { Link } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComment } from '@fortawesome/free-solid-svg-icons';
import Avatar from '../common/Avatar';
import Username from '../common/Username';
import Moment from 'react-moment';

const NewsItem = (props) => (
    <div className="news-post" style={{backgroundImage: `url(${props.post.image})`}}>
        <Link to={"/news/"+props.post.slug}>
            <h2 className="news-title">{props.post.title}</h2>
        </Link>
        <div className="news-bar">
            <Row>
                <Col xs={3}>
                    <div className="news-img pull-left">
                        <Avatar image={props.users[props.post.article.author].avatar} rank={props.ranks[props.users[props.post.article.author].rank]} width="32" height="32" />
                    </div>
                    <h3 className="news-member"><Username user={props.users[props.post.article.author]} /></h3>
                    <span className="news-muted"><Moment fromNow>{props.post.article.created}</Moment></span>
                </Col>
                <Col xs={6}>
                    <h4 className="news-game"><Link to="/" disabled>{props.chapters[props.post.chapter].game.title} News</Link></h4>
                </Col>
                <Col xs={3} className="news-comments">
                    <Link to={'/news/'+props.post.slug} disabled><FontAwesomeIcon icon={faComment} fixedWidth /> 0</Link>
                </Col>
            </Row>
        </div>
    </div>
);


export default NewsItem;


// WEBPACK FOOTER //
// ./src/News/NewsItem.js